import React, { useCallback, useState } from "react";
import { useSelector } from "react-redux";

import { ReactComponent as IconClose } from "../../build/images/image-modal/Close-Circle.svg";
import { ReactComponent as IconDownload } from "../../build/images/image-modal/Document-download.svg";
import { ReactComponent as IconArrowLeft } from "../../build/images/image-modal/ArrowLeft.svg";
import { ReactComponent as IconArrowRight } from "../../build/images/image-modal/ArrowRight.svg";

import urlIngWeb from "../../actions/urlIngWeb";

export default function ModalImage({
  content = [{ file: { path_arquivos: "", name: "" } }],
  linkImg = "",
  openGallery,
  setOpenGallery = () => {},
}) {
  const InfoUsers = useSelector((state) => state.informationusers);

  const [indexModal, setIndexModal] = useState(0);

  const handlePropag = (event) => {
    event.stopPropagation();
  };

  const onDownload = (index) => {
    fetch(`${urlIngWeb + content[index].file.path_arquivos}`).then(
      (response) => {
        response.blob().then((blob) => {
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement("a");
          a.href = url;
          a.download = content[index].file.name;
          a.click();
        });
      }
    );
  };

  const decreaseValue = useCallback(() => {
    if (indexModal > 0) {
      return setIndexModal((value) => value - 1);
    } else {
      return;
    }
  });

  const increaseValue = useCallback(() => {
    if (indexModal < content.length - 1) {
      setIndexModal((value) => value + 1);
    } else {
      return;
    }
  });

  return (
    <div>
      {openGallery && (
        <div
          className={`modal-media ${!openGallery ? "hidden" : "visible"}`}
          onClick={() => setOpenGallery(false)}
        >
          <div className={"modal-media__container"}>
            <div className="modal-media__header">
              {InfoUsers.permdownload && (
                <button
                  className="btn-download"
                  onClick={(e) => {
                    handlePropag(e);
                    onDownload(indexModal);
                  }}
                >
                  <IconDownload />
                  Download
                </button>
              )}
              <IconClose className="modal-icon_close" />
            </div>

            <div className="modal-media__body">
              <button
                className="btn-modal-image"
                disabled={
                  content.length === 1 || content[0] === content[indexModal]
                    ? true
                    : false
                }
                onClick={(e) => handlePropag(e)}
              >
                <IconArrowLeft
                  onClick={() => decreaseValue()}
                  className={`modal-image__icon ${
                    content.length === 1 || content[0] === content[indexModal]
                      ? "disabled"
                      : ""
                  }`}
                />
              </button>

              <div className="fit-container" onClick={(e) => handlePropag(e)}>
                <img
                  src={
                    linkImg
                      ? linkImg
                      : urlIngWeb + content[indexModal].file.path_arquivos
                  }
                  alt="Imagem do modal"
                />
              </div>

              <button
                className="btn-modal-image"
                disabled={
                  content.length === 1 ||
                  content[content.length - 1] === content[indexModal]
                    ? true
                    : false
                }
                onClick={(e) => handlePropag(e)}
              >
                <IconArrowRight
                  onClick={() => increaseValue()}
                  className={`modal-image__icon ${
                    content.length === 1 ||
                    content[content.length - 1] === content[indexModal]
                      ? "disabled"
                      : ""
                  }`}
                />
              </button>
            </div>

            <div className="modal-media__footer">
              <div
                className="footer-img__carrousel"
                onClick={(e) => handlePropag(e)}
              >
                {content.map((fileImg, index) => (
                  <div
                    key={index}
                    className={`img-footer ${
                      indexModal === index ? "img-choose" : ""
                    }`}
                  >
                    <img
                      onClick={() => setIndexModal(index)}
                      style={{
                        width: "100%",
                        height: "100%",
                        cursor: "pointer",
                      }}
                      src={
                        linkImg
                          ? linkImg
                          : urlIngWeb + fileImg.file.path_arquivos
                      }
                      alt=""
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
